const isTransactionComplete = (transaction) => transaction.completionDate
  || (transaction.fundsTransferDate
    && transaction.proofOfAccreditationDate
    && transaction.subscriptionAgreementDate);

export default isTransactionComplete;
